module.exports = __webpack_public_path__ + "asset/image-no-collaborators-7515ae14f2865789.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/collaborator-manage-modal/image/no-collaborators.svg
// module id = pxa1
// module chunks = 0